<mat-toolbar class="toolbar">
  <form class="search-form" [formGroup]="searchFormGroup">
    <mat-form-field subscriptSizing="dynamic">
      <mat-label>Event severity</mat-label>
      <mat-select formControlName="severity">
        <mat-option value="all">All</mat-option>
        <mat-option value="INFO">Info</mat-option>
        <mat-option value="WARNING">Warning</mat-option>
        <mat-option value="CRITICAL">Critical</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field subscriptSizing="dynamic">
      <mat-label>Chargepoint ID</mat-label>
      <input matInput formControlName="chargepointId" />
    </mat-form-field>
    <mat-checkbox formControlName="includeResolved">Include resolved</mat-checkbox>
    <div class="spacer"></div>
    <div class="events-count" *ngIf="eventsCount$ | async as eventsCount">
      <div
        class="event-count info"
        *ngIf="eventsCount['INFO'] > 0"
        [matTooltip]="eventCountTooltipLabel('INFO')"
        [matTooltipPosition]="'below'">
        <mat-icon [inline]="true">info</mat-icon>
        <span class="event-count-value">{{eventsCount['INFO']}}</span>
      </div>
      <span *ngIf="eventsCount['INFO'] > 0 && eventsCount['WARNING'] > 0">|</span>
      <div
        class="event-count warning"
        *ngIf="eventsCount['WARNING'] > 0"
        [matTooltip]="eventCountTooltipLabel('WARNING')"
        [matTooltipPosition]="'below'">
        <mat-icon [inline]="true">warning</mat-icon>
        <span class="event-count-value">{{eventsCount['WARNING']}}</span>
      </div>
      <span *ngIf="eventsCount['WARNING'] > 0 && eventsCount['CRITICAL'] > 0">|</span>
      <div
        class="event-count critical"
        *ngIf="eventsCount['CRITICAL'] > 0"
        [matTooltip]="eventCountTooltipLabel('CRITICAL')"
        [matTooltipPosition]="'below'">
        <mat-icon [inline]="true">error</mat-icon>
        <span class="event-count-value">{{eventsCount['CRITICAL']}}</span>
      </div>
    </div>
    <mat-form-field subscriptSizing="dynamic">
      <mat-label>Order by</mat-label>
      <mat-select [formControl]="orderByFormControl">
        <mat-option value="createdAt">Created at</mat-option>
        <mat-option value="status">Status</mat-option>
        <mat-option value="severity">Severity</mat-option>
      </mat-select>
    </mat-form-field>
  </form>
</mat-toolbar>

<mat-progress-bar *ngIf="searching" mode="indeterminate"></mat-progress-bar>
<ng-container *ngIf="events$ | async as events">
  <div class="events-list" *ngIf="events && events.length > 0; else empty">
    <ng-container *ngFor="let event of (events || []); let i = index">
      <mat-divider *ngIf="i"></mat-divider>
      <div class="event-item">
        <mat-icon class="event-severity" [ngClass]="{'info': event.severity === 'INFO', 'warning': event.severity === 'WARNING', 'critical': event.severity === 'CRITICAL'}">
          <ng-container *ngIf="event.severity === 'INFO'">info</ng-container>
          <ng-container *ngIf="event.severity === 'WARNING'">warning</ng-container>
          <ng-container *ngIf="event.severity === 'CRITICAL'">error</ng-container>
        </mat-icon>
        <div class="column">
          <div class="event-type">{{event.type}}</div>
          <div class="event-created-at">{{event.createdAt | date : "medium"}}</div>
        </div>
        <div class="column">
          <div class="event-status">{{event.status}}</div>
          <div class="event-resolved-at" *ngIf="event.resolvedAt">{{event.resolvedAt | date : "medium"}}</div>
        </div>
        <div class="column">
          <div class="event-chargepoint-id">
            <button mat-icon-button matTooltip="Open chargepoint details" (click)="navigateToChargepoint(event.chargepointId)">
              <mat-icon>open_in_new</mat-icon>
            </button>
            <span matTooltip="Copy to clipboard" (click)="copyToClipboard(event.chargepointId)">
              {{event.chargepointId}}
              <mat-icon>content_copy</mat-icon>
            </span>
          </div>
        </div>
        <div class="spacer"></div>
        <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item disabled>
            <mat-icon>check_circle</mat-icon>
            <span>Acknowledge</span>
          </button>
        </mat-menu>
      </div>
    </ng-container>
  </div>
</ng-container>
<ng-template #empty>
  <div class="disclaimer">
    <mat-icon>sentiment_satisfied</mat-icon>
    <p>No events found</p>
  </div>
</ng-template>